// PaymentRefund.js
import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import {
  Button,
  Card,
  Flex,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  SimpleGrid,
  Spacer,
  Text,
  IconButton,
  Badge,
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  useToast,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import {
  FiChevronLeft,
  FiChevronRight,
  FiEye,
  FiSearch,
  FiEdit,
  FiEdit2,
} from "react-icons/fi";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { get_payment_refund_list } from "../../redux/paymentRefundSlice";
import { get_all_customer_list } from "../../redux/customerSlice";
import DisplayData from "../../components/DisplayData";
import GasCylinderLoader from "../../components/GasCylinderLoader";
import { baseUrl } from "../../utils/utils";
import SearchableDropdown from "../../components/SearchableDropdown";

const PaymentRefund = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useToast();
  const [rows, setRows] = useState(location.state?.prevRows || 10);
  const [page, setPage] = useState(location.state?.prevPage || 1);
  const [initialValue, setInitialValue] = useState(
    location.state?.prevInitialValue || 1
  );
  const { payment_refund_list, total_refund_count, loading } = useSelector(
    (state) => state.paymentRefund
  );
  const { all_customer_list, all_loading } = useSelector(
    (state) => state.customers
  );

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [availableDeposits, setAvailableDeposits] = useState([]);
  const [depositLoading, setDepositLoading] = useState(false);
  const [selectedDeposit, setSelectedDeposit] = useState(null);
  const [uniqueNumber, setUniqueNumber] = useState("");
  const [description, setDescription] = useState("");

  const [submitting, setSubmitting] = useState(false);

  const { 
    isOpen: isCustomerModalOpen, 
    onOpen: onCustomerModalOpen, 
    onClose: onCustomerModalClose 
  } = useDisclosure();
  
  const { 
    isOpen: isDepositModalOpen, 
    onOpen: onDepositModalOpen, 
    onClose: onDepositModalClose 
  } = useDisclosure();
  
  const { 
    isOpen: isUniqueNumberModalOpen, 
    onOpen: onUniqueNumberModalOpen, 
    onClose: onUniqueNumberModalClose 
  } = useDisclosure();

  console.log(availableDeposits,"thisiisfdfed")
  useEffect(() => {
    store.dispatch(get_payment_refund_list({ page, rows }));
  }, [page, rows]);

  const handleCustomerModalClose = () => {
    resetSelectedCustomer();     // reset customer here
    onCustomerModalClose();      // close modal
  };
  
  const resetSelectedCustomer = () => {
    setSelectedCustomer("");
  };
  
  const handleDepositModalClose = () => {
    setDescription("");
    resetSelectedCustomer();     // reset here also
    onDepositModalClose();
  };
  
  const onPrevious = () => {
    if (page > 1) {
      setInitialValue(Number(initialValue) - Number(rows));
      setPage(page - 1);
      store.dispatch(get_payment_refund_list({ page: page - 1, rows }));
    }
  };

  const onNext = () => {
    if (rows * page < total_refund_count) {
      setInitialValue(Number(initialValue) + Number(rows));
      setPage(page + 1);
      store.dispatch(get_payment_refund_list({ page: page + 1, rows }));
    }
  };

  const getStatusBadge = (status) => {
    const statusStr = String(status);
    switch (statusStr) {
      case "0":
        return <Badge colorScheme="yellow">Pending</Badge>;
      case "1":
        return <Badge colorScheme="blue">Assigned</Badge>;
      case "2":
        return <Badge colorScheme="purple">DP Approved</Badge>;
      case "3":
        return <Badge colorScheme="green">Payment Complete</Badge>;
      case "4":
        return <Badge colorScheme="red">Rejected</Badge>;
      default:
        return <Badge colorScheme="gray">Unknown</Badge>;
    }
  };

  const calculateTotalAmount = (details) => {
    if (!details || !details.length) return "0.00";
    return details
      .reduce(
        (total, item) => total + parseFloat(item.security_deposit || 0),
        0
      )
      .toFixed(2);
  };

  const handleViewDetails = (refund, e) => {
    e.stopPropagation();
    navigate("payment-refund-detail", {
      state: {
        refund,
        prevPage: page,
        prevRows: rows,
        prevInitialValue: initialValue,
      },
    });
  };

  const handleAdditionalAssign = () => {
    store.dispatch(get_all_customer_list({ page: 1, rows: 10000 }));
    onCustomerModalOpen();
  };

  const handleCustomerSelect = async () => {
    if (!selectedCustomer) {
      toast({
        title: "Please select a customer",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setDepositLoading(true);
    try {
      const body = new FormData();
      body.append("action", "check_available");
      body.append("userid", selectedCustomer);

      const response = await fetch(baseUrl + "payment_refund.php", {
        method: "POST",
        body: body,
      });
      const data = await response.json();

      if (data.success) {
        setAvailableDeposits(data.data || []);
        onCustomerModalClose();
        onDepositModalOpen();
      } else {
        toast({
          title: "No deposits found",
          status: "info",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Error fetching deposits",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setDepositLoading(false);
    }
  };

  const handleDepositClick = (deposit) => {
    if (deposit.unique_number) return;
  
    setSelectedDeposit(deposit);
    setUniqueNumber("");
    setDescription("");   // Reset here
    onUniqueNumberModalOpen();
  };
  

  const handleSubmitUniqueNumber = async () => {
    if (!uniqueNumber.trim()) {
      toast({
        title: "Please enter a unique number",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setSubmitting(true);
    try {
      const body = new FormData();
      body.append("action", "update_lpg_id");
      body.append("detail_id", selectedDeposit.id);
      body.append("lpg_id", uniqueNumber);
      body.append("refund_description",description);

      const response = await fetch(baseUrl + "payment_refund.php", {
        method: "POST",
        body: body,
      });
      const data = await response.json();

      if (data.success) {
        toast({
          title: "Unique number updated successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        setDescription(""); 
        onUniqueNumberModalClose();
        // Refresh the deposits list
        const refreshBody = new FormData();
        refreshBody.append("action", "check_available");
        refreshBody.append("userid", selectedCustomer);
        const refreshResponse = await fetch(baseUrl + "payment_refund.php", {
          method: "POST",
          body: refreshBody,
        });
        const refreshData = await refreshResponse.json();
        if (refreshData.success) {
          setAvailableDeposits(refreshData.data || []);
        }
      } else {
        toast({
          title: "Failed to update",
          description: data.message || "Please try again",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Error updating unique number",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setSubmitting(false);
    }
  };

  const filteredRefundList = payment_refund_list?.filter(
    (refund) =>
      refund.customer_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      refund.request_id?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      {/* Header Card */}
      <Card
        bg="#fff"
        paddingInline={5}
        paddingBlock={2}
        display="flex"
        flexDirection={["column", "column", "row"]}
        alignItems={["stretch", "stretch", "center"]}
        gap={3}
        flexWrap="wrap"
      >
        <Heading fontSize="xl" flexShrink={0}>
          Payment Refund Requests
        </Heading>

        <Spacer display={["none", "none", "block"]} />

        <Flex
          direction={["column", "row"]}
          gap={2}
          alignItems="center"
          justifyContent={["flex-start", "flex-end"]}
          flex="1"
        >
          <Select
            placeholder="Rows"
            size="md"
            w={["100%", "100px"]}
            value={rows}
            onChange={(e) => {
              setRows(e.target.value);
              setPage(1);
              setInitialValue(1);
              store.dispatch(
                get_payment_refund_list({ page: 1, rows: e.target.value })
              );
            }}
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </Select>

          <Button
            colorScheme="blue"
            size="md"
            onClick={handleAdditionalAssign}
            w={["100%", "auto"]}
          >
            Customer SD
          </Button>

          <InputGroup bg="#f4f5f7" borderRadius={5} w={["100%", "auto"]} maxW="sm">
            <Input
              placeholder="Search by Name or Request ID..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <InputRightElement>
              <FiSearch />
            </InputRightElement>
          </InputGroup>
        </Flex>
      </Card>

      {loading ? (
        <GasCylinderLoader size="sm" loadingText="Loading Payment Refund" />
      ) : (
        <>
          <SimpleGrid minChildWidth="xs" spacing="10px" mt={4}>
            {filteredRefundList?.length > 0 ? (
              filteredRefundList.map((refund) => {
                const hasPending = refund?.details?.some(
                  (d) => String(d.status) === "0"
                );
                const status = hasPending
                  ? "0"
                  : refund?.details?.[0]?.status ?? "0";

                return (
                  <Card
                    key={refund.id}
                    paddingInline={5}
                    paddingBlock={2}
                    cursor="pointer"
                    position="relative"
                    display="flex"
                    flexDirection="column"
                    justifyContent="space-between"
                    _hover={{ boxShadow: "md", transform: "translateY(-3px)" }}
                    transition="all 0.2s ease"
                    onClick={() =>
                      navigate("payment-refund-detail", {
                        state: {
                          refund,
                          prevPage: page,
                          prevRows: rows,
                          prevInitialValue: initialValue,
                        },
                      })
                    }
                  >
                    <Flex justify="space-between" align="center" mb={2}>
                      <Flex align="center" gap={3}>
                        <DisplayData
                          fs="16px"
                          fw="bold"
                          v_color="#007bc9"
                          value={refund.request_id || "NA"}
                        />
                        {getStatusBadge(status)}
                      </Flex>

                      {String(status) === "2" && (
                        <IconButton
                          icon={<FiEdit />}
                          aria-label="Edit"
                          size="sm"
                          colorScheme="blue"
                          variant="ghost"
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate("payment-refund-detail", { state: { refund } });
                          }}
                        />
                      )}
                    </Flex>

                    <Box mt={1}>
                      {[
                        { title: "Customer", value: refund.customer_name },
                        { title: "Reference Order ID", value: refund.orderid },
                        { title: "Refund Date", value: refund.request_date },
                        { title: "Ref. Order Date", value: refund.order_date },
                        {
                          title: "Total Amount",
                          value: `₹${calculateTotalAmount(refund.details)}`,
                        },
                      ].map((item, idx) => (
                        <Flex
                          key={idx}
                          justify="space-between"
                          align="center"
                          mb="1"
                          wrap="nowrap"
                        >
                          <Text
                            fontSize="sm"
                            color="gray.600"
                            flex="1"
                            noOfLines={1}
                          >
                            {item.title}
                          </Text>
                          <Text
                            fontSize="sm"
                            color="gray.800"
                            flex="1"
                            textAlign="right"
                            noOfLines={1}
                          >
                            {item.value || "NA"}
                          </Text>
                        </Flex>
                      ))}
                    </Box>
                  </Card>
                );
              })
            ) : (
              <Text textAlign="center" py={5}>
                No matching records found.
              </Text>
            )}
          </SimpleGrid>

          <Flex justify="flex-end" mt={4}>
            <Card
              alignItems="center"
              flexDirection="row"
              gap={4}
              py={1}
              px={4}
              border="1px solid #E2E8F0"
              boxShadow="sm"
              borderRadius="md"
              bg="white"
            >
              <FiChevronLeft
                cursor="pointer"
                color={page === 1 ? "gray" : "#007bc9"}
                size={28}
                onClick={onPrevious}
              />

              <Flex align="center" gap={2} fontSize="sm" fontWeight="medium">
                <Text>{initialValue}</Text>
                <Text>-</Text>
                <Text>
                  {rows * page >= total_refund_count
                    ? total_refund_count
                    : rows * page}
                </Text>
                <Text>of</Text>
                <Text>{total_refund_count}</Text>
              </Flex>

              <FiChevronRight
                cursor="pointer"
                color={rows * page >= total_refund_count ? "gray" : "#007bc9"}
                size={28}
                onClick={onNext}
              />
            </Card>
          </Flex>
        </>
      )}

     {/* Customer Selection Modal */}
     <Modal isOpen={isCustomerModalOpen} onClose={handleCustomerModalClose}>
     <ModalOverlay />
  <ModalContent>
    <ModalHeader>Select Customer</ModalHeader>
    <ModalCloseButton />
    <ModalBody>
      <FormControl>
        <FormLabel>Customer</FormLabel>
        <SearchableDropdown
          options={all_customer_list || []}
          value={selectedCustomer}
          onChange={(customer) => setSelectedCustomer(customer.id)}
          placeholder="Select customer"
          searchPlaceholder="Search by name, mobile, or email..."
          getOptionLabel={(customer) => customer.name || customer.mobile}
          getOptionValue={(customer) => customer.id}
          getOptionSubLabel={(customer) => {
            const parts = [customer.mobile];
            if (customer.email) parts.push(customer.email);
            return parts.join(" • ");
          }}
          filterOptions={(options, searchTerm) => {
            const term = searchTerm.toLowerCase();
            return options.filter(
              (c) =>
                c.name?.toLowerCase().includes(term) ||
                c.mobile?.toLowerCase().includes(term) ||
                c.email?.toLowerCase().includes(term)
            );
          }}
          isDisabled={all_loading}
          size="md"
        />
      </FormControl>
    </ModalBody>
    <ModalFooter>
    <Button variant="ghost" mr={3} onClick={handleCustomerModalClose}>
              Cancel
      </Button>
      <Button
        colorScheme="blue"
        onClick={handleCustomerSelect}
        isLoading={depositLoading}
      >
        Continue
      </Button>
    </ModalFooter>
  </ModalContent>
</Modal>

      {/* Available Deposits Modal */}
      <Modal 
        isOpen={isDepositModalOpen} onClose={handleDepositModalClose}
        size="xl"
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            Available Security Deposits
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {availableDeposits.length > 0 ? (
              <SimpleGrid columns={1} spacing={3}>
                {availableDeposits.map((deposit) => (
                 <Card
                 key={deposit.id}
                 p={4}
                 cursor={deposit.lpg_id ? "not-allowed" : "pointer"}
                 opacity={deposit.unique_number ? 0.6 : 1}
                 _hover={{ boxShadow: "md", bg: deposit.unique_number ? "white" : "gray.50" }}
                 onClick={() => handleDepositClick(deposit)}
               >
                 <Flex justify="space-between" align="center" mb={2}>
                   <Text fontWeight="bold" color="blue.600">
                     {deposit.product_name}
                   </Text>
               
                   {deposit.lpg_id ? (
                     <Badge colorScheme="green">Done</Badge>
                   ) : (
                     <FiEdit />
                   )}
                 </Flex>
               
                 <Box>
                   <Flex justify="space-between" mb={1}>
                     <Text fontSize="sm" color="gray.600">Order ID:</Text>
                     <Text fontSize="sm">{deposit.orderid}</Text>
                   </Flex>
               
                   <Flex justify="space-between" mb={1}>
                     <Text fontSize="sm" color="gray.600">Count:</Text>
                     <Text fontSize="sm">{deposit.count}</Text>
                   </Flex>
               
                   <Flex justify="space-between" mb={1}>
                     <Text fontSize="sm" color="gray.600">Empty Received:</Text>
                     <Text fontSize="sm">{deposit.empty_received}</Text>
                   </Flex>
               
                   <Flex justify="space-between" mb={1}>
                     <Text fontSize="sm" color="gray.600">Remaining:</Text>
                     <Text fontSize="sm">{deposit.remaining}</Text>
                   </Flex>
               
                   <Flex justify="space-between" mb={1}>
                     <Text fontSize="sm" color="gray.600"> LPG Id:</Text>
                     <Text fontSize="sm" fontWeight="bold">
                       {deposit.lpg_id ? deposit.lpg_id : "Not Assigned"}
                     </Text>
                   </Flex>
               
                   <Flex justify="space-between" mb={1}>
                     <Text fontSize="sm" color="gray.600"> Description</Text>
                     <Text fontSize="sm" fontWeight="bold">
                       {deposit.refund_description ? deposit.refund_description : "N/A"}
                     </Text>
                   </Flex>
               
                   <Flex justify="space-between">
                     <Text fontSize="sm" color="gray.600">Total Security Deposit</Text>
                     <Badge colorScheme="green">₹{deposit.remaining_amount}</Badge>
                   </Flex>
                 </Box>
               </Card>
               
                ))}
              </SimpleGrid>
            ) : (
              <Text textAlign="center" py={5}>
                No deposits available
              </Text>
            )}
          </ModalBody>
          <ModalFooter>
            <Button onClick={handleDepositModalClose}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Unique Number Input Modal */}
      <Modal isOpen={isUniqueNumberModalOpen} onClose={onUniqueNumberModalClose} size="md">
        <ModalOverlay />
        <ModalContent>  
          <ModalHeader>Enter LPG Id</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {selectedDeposit && (
              <Box mb={4}>
                <Text fontSize="sm" color="gray.600">Order ID:</Text>
                <Text fontWeight="bold">{selectedDeposit.orderid}</Text>
                <Text fontSize="sm" color="gray.600" mt={2}>Product:</Text>
                <Text>{selectedDeposit.product_name}</Text>
              </Box>
            )}
            <FormControl>
              <FormLabel>LPG Id</FormLabel>
              <Input
                placeholder="Enter unique number"
                value={uniqueNumber}
                onChange={(e) => setUniqueNumber(e.target.value)}
                type="text"
              />
            </FormControl>

            <FormControl>
              <FormLabel>Description (Optional)</FormLabel>
              <Input
                placeholder="Enter description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                type="text"
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onUniqueNumberModalClose}>
              Cancel
            </Button>
            <Button
              colorScheme="blue"
              onClick={handleSubmitUniqueNumber}
              isLoading={submitting}
            >
              Submit
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default PaymentRefund;